import React, {useState} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import styled, {withTheme} from 'styled-components';
import {Field} from '@nexios/frontend-forms';
import parseText from '../../utils/parseText';
import handleContentAction from '../../utils/handleContentAction';
import {closeContentTemplate} from '../../reducer';
import {gaPopupVisible} from '../../googleAnalytics/step1';

const ContentTemplateContainer = styled.div`
  width: 100%;

  color: ${props => props.theme?.contentTemplate?.color || '#000000'};
  background-color: ${props => props.theme?.contentTemplate?.backgroundColor || 'transparent'};

  ${props => props.theme?.contentTemplate?.padding && `padding: ${props.theme.contentTemplate.padding};`}
`;

function ContentTemplate({html, formContext, theme, history, contentKey, closedContentTemplates, closeContentTemplate}) {
  const [dismissed, setDismissed] = useState(false);

  if (!html || dismissed || closedContentTemplates?.includes(contentKey)) {
    return null;
  }

  const content = parseText(formContext || {}, html);

  return <Field name='frequency' noAutoHide component={({setValue: setFrequency, validate}) => (
    <ContentTemplateContainer
      onClick={handleContentAction({history, formContext, setFrequency, validate, onClose: () => {
        setDismissed(true);
        gaPopupVisible();
        closeContentTemplate(contentKey);
      }})}
      dangerouslySetInnerHTML={{__html: content}}
    />
  )} />;
}

const mapStateToProps = (state) => ({
  closedContentTemplates: state.reducer.closedContentTemplates
});

const mapDispatchToProps = (dispatch) => ({
  closeContentTemplate: (location) => {
    dispatch(closeContentTemplate(location));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(ContentTemplate)));
